import React, { useContext, useMemo, useReducer } from 'react';

import {
  ChangePlanReducer,
  changePlanReducer,
  initialState,
  UpdateActionLayer,
} from '../../reducer/changePlan.reducer';

interface ChangePlanContextType extends ChangePlanReducer {
  dispatch: React.Dispatch<UpdateActionLayer>;
}

const ChangePlanContext = React.createContext<ChangePlanContextType | null>(
  null,
);

const ChangePlanProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(changePlanReducer, initialState);

  const value = useMemo(() => ({ ...state, dispatch }), [state]);

  return (
    <ChangePlanContext.Provider value={value}>
      {children}
    </ChangePlanContext.Provider>
  );
};

export const useChangePlanDetails = () => {
  const context = useContext(ChangePlanContext);

  if (!context) {
    throw new Error(
      'useChangePlanDetails should be used inside ChangePlanProvider.',
    );
  }
  return context;
};

export default ChangePlanProvider;
